import React from 'react';
import PropTypes from 'prop-types';

import {
  AmountFilterWrapper,
  SubmitButton,
  StyledLeftFilterNumFormat,
  StyledRightFilterNumFormat,
} from '~/entities/evaluations/transaction/history/AmountFilterStyles';

import { DEFAULT_CURRENCY_CODE, getCurrencyData } from '~/helpers/i18n';

const AmountFilterPropTypes = {
  handleMinInputChange: PropTypes.func.isRequired,
  handleMaxInputChange: PropTypes.func.isRequired,
  currencyCode: PropTypes.string,
  minBound: PropTypes.obj,
  maxBound: PropTypes.obj,
  handleSubmit: PropTypes.func.isRequired,
};

const AmountFilterDefaultProps = {
  minBound: undefined,
  maxBound: undefined,
  currencyCode: DEFAULT_CURRENCY_CODE,
};

const AmountFilter = ({
  minBound,
  maxBound,
  currencyCode,
  handleMinInputChange,
  handleMaxInputChange,
  handleSubmit,
}) => {
  const { minorUnit } = getCurrencyData({ alphabeticCurrencyCode: currencyCode });
  return (
    <AmountFilterWrapper>
      <StyledLeftFilterNumFormat
        value={minBound?.numberWithDecimal}
        displayType="input"
        thousandSeparator
        decimalScale={minorUnit}
        fixedDecimalScale
        allowNegative
        placeholder={currencyCode}
        onChange={handleMinInputChange}
      />
      to
      <StyledRightFilterNumFormat
        value={maxBound?.numberWithDecimal}
        displayType="input"
        thousandSeparator
        decimalScale={minorUnit}
        fixedDecimalScale
        allowNegative
        placeholder={currencyCode}
        onChange={handleMaxInputChange}
      />
      <SubmitButton onClick={() => handleSubmit({ minBound, maxBound })}>Go</SubmitButton>
    </AmountFilterWrapper>
  );
};

AmountFilter.propTypes = AmountFilterPropTypes;
AmountFilter.defaultProps = AmountFilterDefaultProps;

export default AmountFilter;
